import { fromJS } from 'immutable';

export function request(state) {
    return state.set('liveGameDelete', {
        status: 'IN_PROGRESS'
    });
}

export function finish(state, { liveGameDelete }) {
    return state.set('liveGameDelete', {
        status: 'FINISHED',
        data: liveGameDelete
    });
}

export function error(state) {
    return state.set('liveGameDelete', {
        status: 'ERROR'
    });
}

export function clear(state) {
    return state.set('liveGameDelete', {
        status: '',
        data: ''
    });
}
